module.exports = __webpack_public_path__ + "static/media/logo.01cf3a03.png";